import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  children,
  onClick,
  ariaLabel,
  className,
  isDisabled = false,
}) => {
  return isDisabled ? (
    <button
      className={className}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled
    >
      {children}
    </button>
  ) : (
    <button className={className} aria-label={ariaLabel} onClick={onClick}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default Button;
